module.exports = __webpack_public_path__ + "fonts/4498ee24706459acc2a9adcb00efc56b.txt";